import Vue from "vue"
import VueResource from "vue-resource"

Vue.use(VueResource)
var API_ROOT = (process.env.NODE_ENV === 'production') ? 'https://app.breezy.hr/api' : (process.env.NODE_ENV === 'mm') ? 'https://app.breezy-hire.com/api' : 'http://localhost:8080/api'
//var API_ROOT = 'https://app.breezy.hr/api'

export default {
    init (APP_BASE_URL) {
        if (APP_BASE_URL) {
            API_ROOT = `${APP_BASE_URL}api`
        }
        //console.log(`API_ROOT = ${API_ROOT}`)
    },
    getMessenger ( companyId ) {
        return Vue.http.get(`${API_ROOT}/company/${companyId}/messenger`).then(response => (response.body))
    },
    uploadResume ( file ) {
        return Vue.http.post(`${API_ROOT}/portal/upload`, { file }).then(response => (response.body))
    },
    postCandidate ( { positionId, candidate } ) {
        return Vue.http.post(`${API_ROOT}/messenger/apply/${positionId}`, candidate )
            .then(response => {
                return Object.assign({}, candidate, response.body)
            }, (e) => {
                throw { error: 'postCandidate error' }
            })
    },
    postMessageFromCandidate ( { candidateId, message } ) {
        return Vue.http.post(`${API_ROOT}/messenger/candidate/${candidateId}/conversation`, message)
            .then(response => {
                return response.body
            }, (e) => {
                throw { error: 'postMessageFromCandidate error' }
            })
    },
    getCandidateConversation ( candidateId, startId ) {
        return Vue.http.get(`${API_ROOT}/conversation/${candidateId}?start_id=${startId}`).then(response => {
            return response.body.conversation || []
        }, (e) => {
            throw { error: 'getCandidateConversation error' }
        })
    },
    getAPIRoot () {
        return API_ROOT
    }
}


// WEBPACK FOOTER //
// ./src/services/api.js